import { ClientAppEnum } from '@/enum/client_app';

let clientApp: ClientAppEnum = ClientAppEnum.Unknown;
let appVersion: string | null = null;
let safeAreaInsets: ClientInsets = { top: 0, bottom: 0 };

// uses lower case string for types
const setClientBuild = (
  clientAppString: string,
  appVersionString: string | null | undefined,
  clientSafeAreaInsets: ClientInsets | undefined,
) => {
  if ('snapchat' === clientAppString.toLowerCase()) {
    clientApp = ClientAppEnum.Snapchat;
  } else if ('bitmoji' === clientAppString.toLowerCase()) {
    clientApp = ClientAppEnum.Bitmoji;
  } else {
    clientApp = ClientAppEnum.Unknown;
  }

  if (appVersionString) {
    appVersion = appVersionString;
  }

  if (clientSafeAreaInsets) {
    safeAreaInsets = clientSafeAreaInsets;
  }
};

const getClientApp = (): ClientAppEnum => {
  return clientApp;
};

const getClientAppVersion = (): string | null => {
  return appVersion;
};

/* The client insets are for tall iPhones. */
const getClientInsets = (): ClientInsets => {
  return safeAreaInsets;
};

export default {
  ClientAppEnum,
  setClientBuild,
  getClientApp,
  getClientAppVersion,
  getClientInsets,
};
